// D-038 (2026-05-20): canonical CP → dimension mapping
// CP labels match 00_CANON_READ_FIRST.md locked 2026-05-06.

export interface CpDim {
  key: string;
  cp: number;
  label: string;
  short: string;
  dimensionId: string;
}

export const CP_DIMS: ReadonlyArray<CpDim> = [
  { key: "cp1",  cp: 1,  label: "Project",                                        short: "M", dimensionId: "it_security"   },
  { key: "cp2",  cp: 2,  label: "Need / Pain / Demonstration",                    short: "M", dimensionId: "pain"          },
  { key: "cp3",  cp: 3,  label: "Budget",                                         short: "P", dimensionId: "finance"       },
  { key: "cp4",  cp: 4,  label: "Timeline",                                       short: "P", dimensionId: "timing"        },
  { key: "cp5",  cp: 5,  label: "Authority — Project / Initiative",           short: "T", dimensionId: "champion"      },
  { key: "cp6",  cp: 6,  label: "Technical and Financial Sign-off",               short: "T", dimensionId: "finance"       },
  { key: "cp7",  cp: 7,  label: "Org Structure and Influence Map",                short: "A", dimensionId: "champion"      },
  { key: "cp8",  cp: 8,  label: "Competitive Position",                           short: "C", dimensionId: "competition"   },
  { key: "cp9",  cp: 9,  label: "Compliance — IT Internal and Industry-Specific", short: "C", dimensionId: "compliance"    },
  { key: "cp10", cp: 10, label: "Legal — Contracts, SLAs, Terms",             short: "L", dimensionId: "legal"         },
];

export function dimensionIdForCp(cp: number): string | null {
  return CP_DIMS.find((d) => d.cp === cp)?.dimensionId ?? null;
}
